import util from "./util"

const _menuRoutesMap = Object.freeze({
    "/restrictions": 1,
    "/services": 7,
    "/plates": 8,
    "/plate_groups": 16,
    "/Optimizer": 21,
    "/batchOptimization": 30,
    "/ResultAna": 22,
    "/PermissionControll": "ugaptatr",
    "/dashboard-gestao": 31
});

const getMenuAccess = () => {
    const permissions = util.getLocalVar("permissions");
    let returnValue = {};
    if(permissions){
        const {grantAll, scopes} = permissions;
        returnValue = {..._menuRoutesMap};
        Object.keys(_menuRoutesMap).forEach(mr => {
            returnValue[mr] = grantAll || scopes.indexOf(_menuRoutesMap[mr]) !== -1;
        });

        const canAccessPermissionManagement = util.getLocalVar("canAccessPermissionManagement");
        returnValue['/PermissionControll'] = grantAll && canAccessPermissionManagement;
    }
    return returnValue;
};

const buildMenu = () => { //todo? cache menu in local storage or ram?

};

const _restrictionViewPanelMap = Object.freeze({
    "productGroupPlateRestrictionsPanel": 2,
    "weekdayUtilizationPanel": 3,
    "plateGroupProductPanel": 4,
    "plateGroupPanel": 5,
    "platePanel": 6,
});

const _platesViewPanelMap = Object.freeze({
    "parametersPanel": 9,
    "combinationPanel": 10,
    "mainIngredientPanel": 11,
    "typeProtein": 11,
    "attractivenessPanel": 12,
    "prapartionMethodPanel": 13,
    "cutTypePanel": 14,
    "consumptionHistoryPanel": 15,
    "restrictionRulesPanel": 26
});

const _plateGroupsViewPanelMap = Object.freeze({
    "mainPanel": 17,
    "grouplessPlatesPanel": 18,
    "plateGroupGroupingPanel": 19,
    "plateGroupStandardPanel": 20
});

const _servicesViewPanelMap = Object.freeze({
    "monthSettingsPanel": 27,
    "settingsPanel": 25,
    "portioningSetPanel": 24,
    "daysOutRutSetPanel": 28,
    "linkTypeDishesBetweenServicePanel": 29
});

const mapToPermission = (map) => {
    const permissions = util.getLocalVar("permissions");
    let returnValue = {};
    if(permissions){
        const {grantAll, scopes} = permissions;
        returnValue = {...map};
        Object.keys(map).forEach(mr => {
            returnValue[mr] = grantAll || scopes.indexOf(map[mr]) !== -1;
        });
    }
    return returnValue;
};

const getPermissionToPublishCard = () => {
    const permissions = util.getLocalVar("permissions");
    let hasPermission = false;
    if(permissions){
        const {grantAll, scopes} = permissions;
        hasPermission = grantAll || scopes.indexOf(23) !== -1;
    }
    return hasPermission;
};


export default{
    getMenuAccess,
    getRestrictionsViewPermissions: () => mapToPermission(_restrictionViewPanelMap),
    getPlatesViewPermissions: () => mapToPermission(_platesViewPanelMap),
    getPlateGroupsViewPermissions: () => mapToPermission(_plateGroupsViewPanelMap),
    getServicesViewPermissions: () => mapToPermission(_servicesViewPanelMap),
    getPermissionToPublishCard
}